import { PermissionEnum } from '@electricjs/core_entity-client';

import { useAppSelector } from '@/redux/store';

export const useUserHasOrganizationPermission = (
  permission: PermissionEnum
): boolean => {
  // Use useAppSelector directly to avoid error during logout when loggedUser becomes null
  const organizationId = useAppSelector(
    state => state.loggedUser?.organizationId
  );

  const userOrganizationPermissions =
    useAppSelector(
      state =>
        organizationId &&
        state.loggedUser?.allUserOrganizationRoles?.[organizationId]
          ?.permissions
    ) || [];

  return userOrganizationPermissions.includes(permission);
};
